export default __webpack_public_path__ + "static/realization-2-a7d3d62956234dd792cc03d0ff469ce5.jpg";